import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var copyIcon = /*#__PURE__*/React.createElement("svg", {
  height: "31",
  width: "22",
  viewBox: "0 0 22 31",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.25 31H2.75A2.752 2.752 0 0 1 0 28.25v-13.5A2.752 2.752 0 0 1 2.75 12h.5a.75.75 0 0 1 0 1.5h-.5c-.689 0-1.25.56-1.25 1.25v13.5c0 .689.561 1.25 1.25 1.25h12.5c.689 0 1.25-.561 1.25-1.25v-.5a.75.75 0 0 1 1.5 0v.5A2.752 2.752 0 0 1 15.25 31Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.25 25H8.75A2.752 2.752 0 0 1 6 22.25V9.75A2.752 2.752 0 0 1 8.75 7h10.5A2.752 2.752 0 0 1 22 9.75v12.5A2.752 2.752 0 0 1 19.25 25ZM8.75 8.5c-.689 0-1.25.561-1.25 1.25v12.5c0 .689.561 1.25 1.25 1.25h10.5c.69 0 1.25-.561 1.25-1.25V9.75c0-.689-.56-1.25-1.25-1.25H8.75Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "m18.12 4.547.233-.234-4-4a.5.5 0 0 0-.706 0l-4 4 .233.234a.667.667 0 0 0 .947 0l2.666-2.667V10c0 .368.299.667.667.667h.333V1.873L17.16 4.54a.667.667 0 0 0 .96.007ZM13.5 15.333V14h.333c.369 0 .667.298.667.667V16h-.333a.667.667 0 0 1-.667-.667Zm0-2.666v-1.334h.333c.369 0 .667.299.667.667v1.333h-.333a.667.667 0 0 1-.667-.666Z",
  fill: "currentColor"
}));

export { copyIcon as default };
//# sourceMappingURL=copyIcon.js.map
